import { debounce, clone, noop, isNil, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import 'commons-forms/components/TextArea/TextArea.scss';

class TextArea extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasFocus: false,
            stoppedTyping: false,
        };

        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);

        // TODO #fix -
        // It's probable that this debouncing is causing
        // state to be set during render phase
        this.debounce = debounce(() => {
            this.setState({ stoppedTyping: true });
        }, 300);
    }

    onChange(event) {
        const value = event.target.value;
        this.props.valueChange(value, this.props.name, event);
        this.debounce(value);
    }

    onBlur() {
        this.setState({ hasFocus: false });
        this.props.onBlur();
    }

    onFocus() {
        this.setState({ hasFocus: true });
        this.props.onFocus();
    }

    render() {
        const inputClasses = this.props.isRequired ? 'input-control required' : 'input-control';
        const parentClasses = clone(this.props.classNames);
        let placeholderValue = this.props.label;

        parentClasses.push('TextArea');

        if ((!this.props.isValid && this.state.stoppedTyping) || (!this.props.isValid && this.props.hasBeenSubmit)) {
            parentClasses.push('field-error');
        }

        if (isEmpty(this.props.errorLabel)) {
            parentClasses.push('no-message');
        }
        if ((!isNil(this.props.value) && this.props.value !== '') || this.state.hasFocus) {
            parentClasses.push('not-empty');
            placeholderValue = '';
        }

        return (
            <div className={parentClasses.join(' ')} data-test={this.props.dataTest}>
                <label className="input-label" htmlFor={this.props.name}>
                    {this.props.label}
                </label>
                <textarea
                    id={this.props.name}
                    name={this.props.name}
                    className={inputClasses}
                    placeholder={placeholderValue}
                    value={this.props.value}
                    required={this.props.isRequired}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onChange={this.onChange}
                    minLength={this.props.minLength}
                    maxLength={this.props.maxLength}
                    rows={this.props.rows}
                    cols={this.props.cols}
                    disabled={this.props.isDisabled}
                    wrap={this.props.wrap}
                />
                {!isEmpty(this.props.errorLabel) && <p className="errors-input">{this.props.errorLabel}</p>}
            </div>
        );
    }
}
TextArea.defaultProps = {
    classNames: [],
    errorLabel: '',
    isDisabled: false,
    isRequired: false,
    hasBeenSubmit: false,
    maxLength: null,
    minLength: 0,
    onBlur: noop,
    onFocus: noop,
    rows: null,
    cols: null,
    value: '',
    dataTest: '',
    wrap: 'hard',
};

TextArea.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    valueChange: PropTypes.func.isRequired,
    classNames: PropTypes.arrayOf(PropTypes.string),
    errorLabel: PropTypes.string,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    hasBeenSubmit: PropTypes.bool,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    rows: PropTypes.number,
    cols: PropTypes.number,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    dataTest: PropTypes.string,
    wrap: PropTypes.string,
};

TextArea.displayName = 'TextArea';

export default TextArea;
